<template>
    <Link
        class="flex flex-col gap-1"
        :href="route('student.videos.show-video', { video: video.id })"
    >
        <div class="relative aspect-video">
            <img
                class="aspect-video"
                :src="
                    'https://content.jwplatform.com/thumbs/' +
                    video.token +
                    '-1280.jpg'
                "
            />
            <div
                class="absolute bottom-2 right-2 rounded bg-gray-900 px-2.5 py-1.5 text-[14px] text-white"
            >
                <media-duration
                    :duration-in-seconds="video.duration"
                    :show-seconds="true"
                ></media-duration>
            </div>
        </div>
        <div class="text-[16px] font-medium text-gray-800">
            {{ video.title }}
        </div>

        <div class="flex flex-wrap gap-1 text-[14px]">
            <span class="font-semibold text-gray-625"
                >Topic<span v-if="video.categories.length > 1">s</span>:</span
            >
            <span
                v-for="category in video.categories"
                class="text-gray-625 after:content-[',_'] last-of-type:after:content-['']"
            >
                {{ category.title }}
            </span>
        </div>
    </Link>
</template>
<script>
import MediaDuration from "@/Components/MediaDuration.vue";

export default {
    name: "StudentVideoCard",
    components: { MediaDuration },
    props: {
        video: {},
        showDate: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
